import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

/**
 * Base modal component
 */
@Component({
  selector: 'atx-modal',
  templateUrl: './modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalComponent {
  /** Event emitted on modal close */
  @Output() public modalClose = new EventEmitter();
  /** whether the modal should be shown, or not */
  @Input() public show = false;
  /** whether the modal should show close button */
  @Input() public showCloseBtn = true;
  /** size of the modal */
  @Input() public size = 'md';
  /** whether the modal should close on click outside */
  @Input() public closeOnOutside = false;

  /**
   * Marks show as false and emits modalClose.
   */
  public close() {
    this.show = false;
    this.modalClose.emit();
  }

  public clickOutside() {
    if (this.closeOnOutside && this.show) {
      this.close();
    }
  }
}
